"use client";

import { useRef } from "react";
import Image from "next/image";
import { getTranslationFor } from "@/text/translations";
import styles from "./WhoIsThisFor.module.css";

const articles = [
  {
    id: 1,
    title: "CRM Providers",
    description:
      "CRM systems built for real estate agencies. PFDN enables CRMs to connect directly with Property Finder, giving their clients seamless access to listings, leads, and data.",
    image: "/images/crm_provider.jpg",
  },
  {
    id: 2,
    title: "Lead Management Platforms",
    description:
      "Solutions that specialize in lead tracking, enrichment, and performance insights. PFDN ensures agencies can capture, route, and optimize leads effectively across all channels.",
    image: "/images/lead_management.jpg",
  },
  {
    id: 3,
    title: "Custom Software Developers",
    description:
      "Technology partners who build bespoke solutions and integrations for brokerages and property developers. PFDN offers a standardized way to connect with Property Finder data and services.",
    image: "/images/custom_software.jpg",
  },
];

export default function WhoIsThisFor() {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>
        {getTranslationFor("home.whoIsThisFor.title")}
      </h2>
      <div className={styles.scrollContainer} ref={scrollRef}>
        <ul className={styles.cardsWrapper}>
          {articles.map((article) => (
            <li key={article.id} className={styles.card}>
              <div className={styles.imageWrapper}>
                <Image
                  src={article.image}
                  alt={article.title}
                  className={styles.image}
                  fill
                  style={{ objectFit: "cover" }}
                  unoptimized={true}
                />
              </div>
              <div className={styles.content}>
                <h3 className={styles.cardTitle}>{article.title}</h3>
                <p className={styles.description}>{article.description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
